import styled from 'styled-components';
import HelperText from '../../../HelperText';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px;
`;

export const StyledTextarea = styled.textarea`
  border: ${({ theme }) => `1px solid ${theme.configs.secondaryBox.fontColor}`};
  border-radius: 5px;
  background-color: ${({ theme }) => theme.configs.tertiaryBox.bgColor};
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-size: 16px;
  font-weight: 400;
  height: auto;
  line-height: 1.5;
  padding: 7px 9px;
  resize: none;
  width: 100%;
  font-family: inherit;

  ::placeholder {
    color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
    opacity: 0.75;
  }
`;

export const CharacterCounter = styled(HelperText)`
  margin-left: auto;
`;
